"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarSteel = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var Card_1 = require("../Card");
var LunarSteel = (function (_super) {
    __extends(LunarSteel, _super);
    function LunarSteel() {
        return _super.call(this, {
            name: CardName_1.CardName.LUNAR_STEEL,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON],
            cost: 5,
            metadata: {
                cardNumber: 'M87',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('Your steel resources are worth 1 M€ extra.', function (eb) {
                        eb.steel(1).startEffect.plus(Size_1.Size.SMALL).megacredits(1);
                    });
                }),
            },
        }) || this;
    }
    ;
    LunarSteel.prototype.play = function (player) {
        player.increaseSteelValue();
        return undefined;
    };
    LunarSteel.prototype.onDiscard = function (player) {
        player.decreaseSteelValue();
    };
    return LunarSteel;
}(Card_1.Card));
exports.LunarSteel = LunarSteel;
//# sourceMappingURL=LunarSteel.js.map